// Contest entry deadline — Sept 30, 2026 (end of day, Eastern).
export const CONTEST_DEADLINE = new Date('2026-09-30T23:59:59-04:00');

export function contestDaysLeft() {
  const ms = CONTEST_DEADLINE.getTime() - Date.now();
  return ms <= 0 ? 0 : Math.ceil(ms / 86400000);
}

// Days left until an arbitrary YYYY-MM-DD deadline (end of that day, Eastern).
export function daysLeftUntil(dateStr) {
  try {
    const d = new Date(`${String(dateStr).slice(0, 10)}T23:59:59-04:00`);
    if (isNaN(d.getTime())) return contestDaysLeft();
    const ms = d.getTime() - Date.now();
    return ms <= 0 ? 0 : Math.ceil(ms / 86400000);
  } catch {
    return contestDaysLeft();
  }
}
